module.exports = __webpack_public_path__ + "img/topImg1.c4bf5937.png";